import React, { useState } from "react";
import { SearchList } from "./";
import { FaSearch } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const IconsList = ({ icons, toggleIcon, setIcon }) => {
  const { t } = useTranslation();
  const [searchText, setsearchText] = useState("");

  const changeIcon = (icon) => {
    setIcon(icon);
    toggleIcon();
  };

  const filteredIcons = icons.filter((icon) => {
    return icon.caption.includes(searchText);
  });

  const searchIcon = (e) => {
    setsearchText(e.target.value);
  };

  return (
    <div style={{ minHeight: "80vh" }}>
      <div>
        <i className="circleTop icon-plug text-center m-auto"></i>
        <div className="text-center mt-2">
          <p className="m-0">{t("انتخاب آیکون")}</p>
        </div>
      </div>
      <div className="inputs d-flex align-items-center text-muted w-100 px-3 mt-4">
        <FaSearch />
        <input
          type="text"
          placeholder={t("جستجوی آیکون")}
          onChange={searchIcon}
          name="caption"
          className="w-100 text-right fn mr-2"
        />
      </div>
      <div className="d-flex justify-content-center flex-wrap mt-4">
        <SearchList filteredIcons={filteredIcons} changeIcon={changeIcon} />
      </div>
    </div>
  );
};

export { IconsList };
